import React, { useContext } from "react";
import AliceGPTContext from "../../Context/AliceGPT/AliceGPTContext";

function useAliceGPT() {
    const [state, dispatch] = useContext(AliceGPTContext);

    return [state, dispatch];
}

export default useAliceGPT;